var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.text))]),(_vm.timer)?_c('p',[_vm._v(" Elaspsed: "),_c('b',[_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.second))])]):_vm._e(),_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }